/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ParticipantStatus = {
    Accepted: 'Accepted',
    Refused: 'Refused',
    CancelledUser: 'CancelledUser',
    CancelledEvent: 'CancelledEvent',
    CancelledNoShow: 'CancelledNoShow',
    CancelledPreAuth: 'CancelledPreAuth',
    Pending: 'Pending',
    Invited: 'Invited',
} as const;

export type ParticipantStatus = typeof ParticipantStatus[keyof typeof ParticipantStatus];



